module.exports = __webpack_public_path__ + "img/16.d7ab9142.jpg";